import { ComponentType } from 'react';

import { FinancialAttachmentCard, PayerAddressCard } from '../../../../../../components/cards/financial';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import FinancialPage from '../../../../../../features/FinancialPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS, PAYER_ADDRESS_FIELDS } from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

type Field = {
  key: string;
  conditionalCountryArray?: string[];
};

type Card = {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  hideSameAs?: boolean;
  fields?: Field[];
};

type PageTemplate = {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  cards: Card[];
};

const conditionalCountryArray: string[] = [
  'TR',
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE'
];

const payerPageTemplate: PageTemplate = {
  route: PAGE_ROUTES.financial,
  Component: FinancialPage,
  cards: [
    {
      key: CARD_CATEGORIES.payer,
      Component: PayerAddressCard,
      hideSameAs: true,
      fields: [
        { key: PAYER_ADDRESS_FIELDS.address },
        { key: PAYER_ADDRESS_FIELDS.taxNumber1, conditionalCountryArray },
        { key: PAYER_ADDRESS_FIELDS.taxNumber2 },
        { key: PAYER_ADDRESS_FIELDS.telephone1 },
        { key: PAYER_ADDRESS_FIELDS.telephone2 }
      ]
    },
    {
      key: CARD_CATEGORIES.financialAttachmentCard,
      Component: FinancialAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.financialCardAttachment }]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

const pages: PageTemplate[] = [payerPageTemplate];

export default pages;